import React, { useState } from 'react';
import styles from './bowtie-meatball-menu.scss';
import { withCallsToActions } from 'app/area/case/features';
import { HeaderPanelProps } from 'app/components';
import { AddNewConnectedCasesDropdown } from 'app/components/add-new-cases-dropdown/add-new-connected-cases-dropdown';
import { AddNewConnectedCasesWireData } from 'app/area/case/features/calls-to-actions/types';
import { useSharedState } from 'app/infrastructure/redux/hooks';
import { UserType } from 'app/types-shared';
import { MeatballMenu } from 'ui/common/dropdown-menu/meatball-menu';

interface BowtieMeatballMenuProps {
  caseId: number;
  callsToActions?: HeaderPanelProps['callsToActions'];
}

export const BowtieMeatBallMenuContainer = ({
  callsToActions: fetchCallsToActions,
  caseId
}: BowtieMeatballMenuProps) => {
  const [callsToActions, setCallsToActions] = useState(undefined);
  const sharedState = useSharedState();
  const allowForCurrentUser = sharedState?.userType?.v !== UserType.basic;

  const onExpandMenu = async () => {
    if (caseId) {
      const options = await fetchCallsToActions(caseId);
      setCallsToActions(options);
    }
  };

  const renderDropdown = <div className={styles.bowtiedropdownContent}>
    <ul>
      {allowForCurrentUser &&
        callsToActions?.addNewConnectedCases?.map((addNewConnectedCase: AddNewConnectedCasesWireData, index: number) => {
          return <AddNewConnectedCasesDropdown
            entityId={caseId}
            addNewConnectedCaseButtons={addNewConnectedCase.newCaseButtons}
            textLabelMenu={addNewConnectedCase.label}
            key={index}
          />;
        })}
    </ul>
  </div>;

  return (
    <MeatballMenu onExpandMenu={onExpandMenu}>
      {renderDropdown}
    </MeatballMenu>
  );
};
export const BowtieMeatBallMenu = withCallsToActions(BowtieMeatBallMenuContainer);
